import React from 'react'

import DateRangeView from '../DateRange/View'

export default function DatetimeRangeView(
	props: React.ComponentProps<typeof DateRangeView>
) {
	return <DateRangeView {...props} showTimePicker />
}
